import { useState } from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    RowList,
    Sheet,
    TextRow,
    YStack,
} from 'smoothie';

const DEPOSIT_LIMITS = [
    { title: 'Per day', value: '$5,000.00' },
    { title: 'Per month', value: '$10,000.00' },
    { title: 'Checks per month', value: '5' },
] as const;

interface CheckDepositLimitsSheetProps {
    isOpen: boolean;
    onClose: () => void;
}

const CheckDepositLimitsSheet = ({
    isOpen,
    onClose,
}: CheckDepositLimitsSheetProps) => (
    <Sheet
        isOpen={isOpen}
        onClose={onClose}
        title="Deposit limits"
        showCloseButton
    >
        <YStack gap={16}>
            <BodyMediumRegular color="$gray1000" textAlign="center">
                All checks deposited in solo or joint accounts count towards
                your monthly limit.
            </BodyMediumRegular>
            <RowList>
                {DEPOSIT_LIMITS.map(({ title, value }) => (
                    <TextRow key={title} title={title} secondaryText={value} />
                ))}
            </RowList>
        </YStack>
    </Sheet>
);

export const CheckDepositLimitsButton = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button
                variant={ButtonVariant.TERTIARY}
                size={ButtonSize.LARGE}
                text="View deposit limits"
                onPress={() => {
                    setIsOpen(true);
                }}
            />
            <CheckDepositLimitsSheet
                isOpen={isOpen}
                onClose={() => {
                    setIsOpen(false);
                }}
            />
        </>
    );
};
